import _ from '@/setup/lodash';
import store from '@/store';

import {
  MISC_INIT_DATA,
  MISC_INIT_COUNTERS,
  MISC_FETCH_MESSENGERS,
  MISC_FETCH_BRANDS,
  MISC_FETCH_TIMEZONES,
  MISC_FETCH_COUNTRIES,
  MISC_FETCH_REGIONS,
  MISC_FETCH_PAYMENTS_SYSTEMS,
  MISC_FETCH_SPORT_TYPE,
  MISC_FETCH_SPORT_LEAGUE,
  MISC_FETCH_LANGUAGES,
  MISC_FETCH_NOTE_TAGS,
  MISC_FETCH_PAYMENT_METHODS,
  MISC_CONNECTION_ENABLED,
  MISC_CONNECTION_DISABLED,
  MISC_FETCH_DNS_HOSTING_PROVIDERS,
  MISC_FETCH_DOMAIN_REGISTRAR_PROVIDERS,
  MISC_GET_POST_PLATFORM,
  MISC_GET_CURRENCIES,
  MISC_GET_CUSTOMER_CURRENCIES,
  MISC_GET_CUSTOMER_LANGUAGES,
  MISC_GET_SETTINGS,
} from '../action_types/misc';


const getters = {
  brands: (state) => state.brands,
  apiMessengers: (state) => state.apiMessengers,
  timezones: (state) => state.timezones,
  countries: (state) => state.countries,
  countriesIndex: (state) => state.countriesIndex,
  countriesNameMap: (state) => state.countries.reduce((acc, country) => {
    acc[country.code] = country.name;
    return acc;
  }, {}),
  regions: (state) => state.regions,
  paymentsSystems: (state) => state.paymentsSystems,
  sportType: (state) => state.sportType,
  sportLeague: (state) => state.sportLeague,
  noteTags: (state) => state.noteTags,
  groups: (state) => state.groups,
  languages: (state) => state.languages,
  paymentMethods: (state) => state.paymentMethods,
  paymentPeriods: (state) => state.paymentPeriods,
  messengers: (state) => state.messengers,
  countersEnabled: (state) => state.countersEnabled,
  connectionEnabled: (state) => state.connectionEnabled,
  dnsHostingProviders: (state) => state.dnsHostingProviders,
  domainRegistrarProviders: (state) => state.domainRegistrarProviders,
  postPlatform: (state) => state.postPlatform,
  currencies: (state) => state.currencies,
  customerCurrencies: (state) => state.customerCurrencies,
  activeCustomerCurrency: (state) => {
    if (state.customerCurrencies.length) {
      if (state.customerCurrencies[0].is_default) {
        return state.customerCurrencies[0];
      }

      return state.customerCurrencies.find((el) => el.is_default) || {};
    }

    return {};
  },
  customerLanguages: (state) => state.customerLanguages,
};

const actions = {
  [MISC_INIT_DATA]: ({ dispatch, commit }) => Promise.all([
    commit(MISC_INIT_COUNTERS),
    dispatch(MISC_FETCH_MESSENGERS),
    dispatch(MISC_FETCH_TIMEZONES),
    dispatch(MISC_FETCH_COUNTRIES),
    dispatch(MISC_FETCH_LANGUAGES),
    dispatch(MISC_FETCH_NOTE_TAGS),
    dispatch(MISC_FETCH_PAYMENT_METHODS),
    dispatch(MISC_FETCH_DNS_HOSTING_PROVIDERS),
    dispatch(MISC_FETCH_DOMAIN_REGISTRAR_PROVIDERS),
    dispatch(MISC_GET_POST_PLATFORM),
    dispatch(MISC_GET_CURRENCIES),
    dispatch(MISC_GET_CUSTOMER_CURRENCIES),
    dispatch(MISC_GET_CUSTOMER_LANGUAGES),
  ]),

  [MISC_FETCH_MESSENGERS]: ({ commit }) => {
    store.$api.getMessengers()
      .then((response) => {
        commit(MISC_FETCH_MESSENGERS, response.data.payload);
      });
  },

  [MISC_FETCH_BRANDS]: async ({ commit }) => {
    if (store.getters['auth/adminAcl'].is_superuser
    || store.getters['auth/adminAcl'].teams.length) {
      const response = await store.$api.getSiteSettings();
      commit(MISC_FETCH_BRANDS, response.data.payload);
    }
  },

  [MISC_FETCH_TIMEZONES]: ({ commit }) => {
    store.$api.getTimezones()
      .then((response) => {
        commit(MISC_FETCH_TIMEZONES, response.data.payload);
      });
  },

  [MISC_FETCH_COUNTRIES]: ({ commit }) => {
    store.$api.getCountries()
      .then((response) => {
        commit(MISC_FETCH_COUNTRIES, response.data.payload);
      });
  },

  [MISC_FETCH_REGIONS]: async ({ commit }) => {
    const { data } = await store.$api.getRegions();
    commit(MISC_FETCH_REGIONS, data.payload);
  },
  [MISC_FETCH_PAYMENTS_SYSTEMS]: async ({ commit }) => {
    const { data } = await store.$api.getPaymentSystems();
    commit(MISC_FETCH_PAYMENTS_SYSTEMS, data.payload.map((obj) => _.mapKeys(obj, (value, key) => (key === 'id' ? 'code' : key))));
  },
  [MISC_FETCH_SPORT_TYPE]: async ({ commit }, payload) => {
    const { data } = await store.$api.getSportCategories({ site_id: payload });
    commit(MISC_FETCH_SPORT_TYPE, data.payload.map((obj) => _.mapKeys(obj, (value, key) => (key === 'id' ? 'code' : key))));
  },
  [MISC_FETCH_SPORT_LEAGUE]: async ({ commit }, payload) => {
    const { data } = await store.$api.getSportLeagues({ site_id: payload });
    commit(MISC_FETCH_SPORT_LEAGUE, data.payload.map((obj) => _.mapKeys(obj, (value, key) => (key === 'id' ? 'code' : key))));
  },

  [MISC_FETCH_LANGUAGES]: async ({ commit }) => {
    const { data } = await store.$api.getLanguages();
    commit(MISC_FETCH_LANGUAGES, data.payload);
  },

  [MISC_FETCH_NOTE_TAGS]: ({ commit }) => {
    store.$api.getNoteTags()
      .then((response) => {
        commit(MISC_FETCH_NOTE_TAGS, response.data.payload);
      });
  },
  [MISC_FETCH_PAYMENT_METHODS]: ({ commit }) => {
    if (localStorage.getItem('active-team') || (!localStorage.getItem('active-team') && store.getters['auth/adminAcl'].is_superuser)) {
      store.$api.getPaymentMethods()
        .then((response) => {
          commit(MISC_FETCH_PAYMENT_METHODS, response.data.payload);
        });
    }
  },

  [MISC_FETCH_DNS_HOSTING_PROVIDERS]: async ({ commit }) => {
    if (store.getters['auth/adminAcl'].is_superuser || store.getters['auth/currentAcl'].dns_hosting_accounts_view === 'allow') {
      const { data } = await store.$api.getDNSHostingProviders();
      commit(MISC_FETCH_DNS_HOSTING_PROVIDERS, data.payload);
    }
  },

  [MISC_FETCH_DOMAIN_REGISTRAR_PROVIDERS]: async ({ commit }) => {
    if (store.getters['auth/adminAcl'].is_superuser || store.getters['auth/currentAcl'].domain_registrar_accounts_view === 'allow') {
      const { data } = await store.$api.getDomainRegistrarProviders();
      commit(MISC_FETCH_DOMAIN_REGISTRAR_PROVIDERS, data.payload);
    }
  },

  [MISC_GET_POST_PLATFORM]: async ({ commit }) => {
    const { data } = await store.$api.getPostPlatform();
    commit(MISC_GET_POST_PLATFORM, data.payload);
  },
  [MISC_GET_CURRENCIES]: async ({ commit }) => {
    const { data } = await store.$api.getCurrencies();
    commit(MISC_GET_CURRENCIES, data.payload);
  },
  [MISC_GET_CUSTOMER_CURRENCIES]: async ({ commit }) => {
    const { data } = await store.$api.getMiscCustomerCurrencies();
    commit(MISC_GET_CUSTOMER_CURRENCIES, data.payload);
  },
  [MISC_GET_CUSTOMER_LANGUAGES]: async ({ commit, rootGetters }) => {
    const { data } = await store.$api.getLanguages({ code: rootGetters['reports/supportedLanguages'] });
    commit(MISC_GET_CUSTOMER_LANGUAGES, data.payload);
  },
};

const mutations = {
  [MISC_CONNECTION_ENABLED]: (state) => {
    state.connectionEnabled = true;
  },
  [MISC_CONNECTION_DISABLED]: (state) => {
    state.connectionEnabled = false;
  },
  [MISC_INIT_COUNTERS]: (state) => {
    state.countersEnabled = true;
  },
  [MISC_FETCH_MESSENGERS]: (state, payload) => {
    state.apiMessengers = _.cloneDeep(payload);
  },
  [MISC_FETCH_BRANDS]: (state, payload) => {
    state.brands = _.cloneDeep(payload);
  },
  [MISC_FETCH_TIMEZONES]: (state, payload) => {
    state.timezones = _.cloneDeep(payload);
  },
  [MISC_FETCH_COUNTRIES]: (state, payload) => {
    state.countries = _.cloneDeep(payload);
    const indexData = {};
    payload.forEach((item) => {
      indexData[item['code']] = item;
    });
    state.countriesIndex = _.cloneDeep(indexData);
  },
  [MISC_FETCH_REGIONS]: (state, payload) => {
    state.regions = _.cloneDeep(payload);
  },
  [MISC_FETCH_PAYMENTS_SYSTEMS]: (state, payload) => {
    state.paymentsSystems = _.cloneDeep(payload);
  },
  [MISC_FETCH_SPORT_TYPE]: (state, payload) => {
    state.sportType = _.cloneDeep(payload);
  },
  [MISC_FETCH_SPORT_LEAGUE]: (state, payload) => {
    state.sportLeague = _.cloneDeep(payload);
  },
  [MISC_FETCH_NOTE_TAGS]: (state, payload) => {
    state.noteTags = _.cloneDeep(payload);
  },
  [MISC_FETCH_PAYMENT_METHODS]: (state, payload) => {
    state.paymentMethods = _.cloneDeep(payload);
  },

  [MISC_FETCH_DNS_HOSTING_PROVIDERS]: (state, payload) => {
    state.dnsHostingProviders = payload;
  },

  [MISC_FETCH_DOMAIN_REGISTRAR_PROVIDERS]: (state, payload) => {
    state.domainRegistrarProviders = payload;
  },

  [MISC_FETCH_LANGUAGES]: (state, payload) => {
    state.languages = payload;
  },

  [MISC_GET_POST_PLATFORM]: (state, payload) => {
    state.postPlatform = payload;
  },
  [MISC_GET_CURRENCIES]: (state, payload) => {
    state.currencies = payload;
  },
  [MISC_GET_CUSTOMER_CURRENCIES]: (state, payload) => {
    state.customerCurrencies = payload;
  },
  [MISC_GET_CUSTOMER_LANGUAGES]: (state, payload) => {
    state.customerLanguages = payload;
  },
  [MISC_GET_SETTINGS]: (state, payload) => {
    state.miscSettings = payload;
  },
};

const state = {
  miscSettings: {},
  countersEnabled: Boolean,
  connectionEnabled: Boolean,
  currencies: [],
  customerCurrencies: [],

  apiMessengers: [],
  brands: [],
  timezones: [],
  countries: [],
  countriesIndex: [],
  regions: [],
  paymentsSystems: [],
  sportType: [],
  sportLeague: [],
  languages: [],
  customerLanguages: [],
  noteTags: [],
  groups: [],
  paymentMethods: [],
  dnsHostingProviders: [],
  domainRegistrarProviders: [],
  postPlatform: [],
  paymentPeriods: [
    'manual',
    'net7',
    'net15',
    'net30',
    'net60',
  ],
  messengers: [
    'telegram',
    'viber',
    'whatsapp',
    'facebook',
    'instagram',
    'twitter',
  ],
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};
